const alt = require('components/alt');
const CartActions = require('./cart_actions.js');

class CartStore {
  constructor() {
    this.resetState();

    this.bindListeners({
      handleCartLoaded: CartActions.CART_LOADED,
    });
  }

  handleCartLoaded(response) {
    this.cart = response;
  }

  resetState() {
    this.cart = null;
  }
}

module.exports = alt.createStore(CartStore, 'CartStore');



// WEBPACK FOOTER //
// ./javascripts/components/cart/cart_store.js